module.exports = __webpack_public_path__ + "img/accident1.1f53ab17.png";